import React from "react";
import {
    VenueManagement1Icon,
    VenueManagement2Icon,
    VenueManagement3Icon,
    VenueManagement4Icon,
    VenueManagement5Icon,
    VenueManagement6Icon,
    VenueManagement7Icon,
    VenueManagement8Icon,
    VenueManagement9Icon,
    VenueManagement10Icon,
    VenueManagement11Icon,
    VenueManagement12Icon,
} from "../../assets/icons"
import { StyledList, StyledSectionContent } from "./ui";

const VenueManagement = () => {
  return (

      <StyledSectionContent id="venue_management">
          <StyledList>
              <p>
                  <VenueManagement1Icon />
                  <span>Members & subscriptions</span>
              </p>
              <p>
                  <VenueManagement2Icon />
                  <span>Real time Calendars</span>
              </p>
              <p>
                  <VenueManagement3Icon />
                  <span>Booking App</span>
              </p>
              <p>
                  <VenueManagement10Icon />
                  <span>Venue Automation</span>
              </p>
              <p>
                  <VenueManagement4Icon />
                  <span>Statements & Invoices</span>
              </p>
              <p>
                  <VenueManagement5Icon />
                  <span>Online Payments</span>
              </p>
              <p>
                  <VenueManagement6Icon />
                  <span>Availability</span>
              </p>
              <p>
                  <VenueManagement11Icon />
                  <span>Staff Accounts</span>
              </p>
              <p>
                  <VenueManagement7Icon />
                  <span>24/7 Support</span>
              </p>
              <p>
                  <VenueManagement8Icon />
                  <span>Customisation</span>
              </p>
              <p>
                  <VenueManagement9Icon />
                  <span>Customer data</span>
              </p>
              <p>
                  <VenueManagement12Icon />
                  <span>Account management</span>
              </p>
          </StyledList>
      </StyledSectionContent>
  );
};

export default VenueManagement;
